module.exports = __webpack_public_path__ + "img/blouse_2.c31190fe.png";